import React, { useEffect } from 'react';

import { useLocalStorage } from 'Hooks/useStorage';

import { EMAIL_VERIFICATION_STATUS, EMAIL_VERIFICATION_STATUS_VERIFIED } from '../EmailVerification.constants';
import { ErrorVerificationUI } from '../components/ErrorVerificationUI';

const ErrorEmailVerification = () => {
  const [
    emailVerificationStorage,
    setEmailVerificationStorage,
  ] = useLocalStorage(EMAIL_VERIFICATION_STATUS);

  useEffect(() => {
    if (emailVerificationStorage === EMAIL_VERIFICATION_STATUS_VERIFIED) {
      setEmailVerificationStorage('');
    }
  }, [emailVerificationStorage]);

  return <ErrorVerificationUI />;
};

export default ErrorEmailVerification;
